












import { Vue, Component, Prop } from 'vue-property-decorator';

@Component({})
export default class Boolean extends Vue {
    @Prop() bool!: boolean;
}
